import { CheckCircle2, Clock, AlertCircle } from 'lucide-react'

const BYTES_PER_KB = 1024
const SIZE_LABELS = ['B', 'KB', 'MB', 'GB', 'TB']
const ICON_CLASSES = 'h-4 w-4'

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B'
  const i = Math.floor(Math.log(bytes) / Math.log(BYTES_PER_KB))
  return `${String(parseFloat((bytes / Math.pow(BYTES_PER_KB, i)).toFixed(1)))} ${SIZE_LABELS[i] ?? 'B'}`
}

export function formatStatusLabel(status: string): string {
  return status.charAt(0).toUpperCase() + status.slice(1)
}

export function formatPriorityLabel(priority: string): string {
  return priority.charAt(0).toUpperCase() + priority.slice(1)
}

export function formatRole(role: string): string {
  return role
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function getStatusIcon(status: string): React.ReactElement {
  if (status === 'active') {
    return <CheckCircle2 className={`${ICON_CLASSES} text-green-500`} />
  }
  if (status === 'pending') {
    return <Clock className={`${ICON_CLASSES} text-yellow-500`} />
  }
  return <AlertCircle className={`${ICON_CLASSES} text-red-500`} />
}

const PERCENT_CRITICAL = 90
const PERCENT_WARNING = 70

export function progressBarColour(percent: number): string {
  if (percent >= PERCENT_CRITICAL) return 'bg-red-500'
  if (percent >= PERCENT_WARNING) return 'bg-amber-500'
  return 'bg-green-500'
}
